export class Structure {
  public id: number;
  public name: string;
  public sector_name: string;
  public data: { sections: any };
  public is_example = false;
  public created_at: Date;
  public updated_at: Date;
}
